import React from 'react';
import Header from '../components/resuableComponents/Header';
import Footer from '../components/resuableComponents/Footer';
import { useLocation } from 'react-router-dom';
import { Container, Grid, Box } from '@mui/material';
import BusSummaryForm from '../form/BusSummaryForm';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { setModal } from '../reducers/UiReducer';
import { useDispatch } from 'react-redux';
import CoupanModal from '../components/resuableComponents/CoupanModal';
import Navbar from '../components/resuableComponents/Navbar/Navbar';

const steps = ['Review', 'Travel Detail', 'Payment'];

const BusDetailPage = () => {
	const location = useLocation();
	const dispatch = useDispatch();
	console.log('location', location);
	function timeConvertbus(a) {
		let arhour = Math.floor(a / 60);
		if (arhour > 24) {
			arhour = arhour - 24;
		}
		let armin = a % 60;
		let format = `${arhour}:${armin === 0 ? '00' : armin}:00`;
		function formatTime(timeString) {
			const [hourString, minute] = timeString.split(':');
			const hour = +hourString % 24;
			return (hour % 12 || 12) + ':' + minute + (hour < 12 ? ' AM' : ' PM');
		}
		return formatTime(format);
		console.log('first', armin);
	}
	return (
		<div>
			<Navbar />
			<Box style={{ padding: 20 }}>
				<Stepper activeStep={1} alternativeLabel>
					{steps.map((label) => (
						<Step key={label}>
							<StepLabel
								sx={{
									'.MuiStepLabel-label': {},
								}}>
								{label}
							</StepLabel>
						</Step>
					))}
				</Stepper>
			</Box>
			<Container style={{ marginTop: 10, marginBottom: 50 }}>
				<Grid container spacing={4}>
					<Grid item xs={8}>
						<Box
							style={{
								boxShadow: '0 0 10px rgba(0,0,0,.3)',
								backgroundColor: '#FFF',
								padding: 30,
								borderRadius: 3,
							}}>
							<Grid container alignItems={'center'}>
								<Grid item xs={6}>
									<Box style={{ display: 'flex', alignItems: 'center' }}>
										<h1 style={{ fontSize: 22 }}>
											{location.state.item.travels}
										</h1>
										<p style={{ color: 'grey', fontSize: 12, marginLeft: 20 }}>
											{location.state.item.AC === 'true' ? 'AC' : 'Non-AC'}
										</p>
									</Box>
									<Box
										style={{
											display: 'flex',
											alignItems: 'center',
											marginTop: 10,
										}}>
										<h3>{timeConvertbus(location.state.item.departureTime)}</h3>
										<span style={{ marginLeft: 10 }}>-------------------</span>
										<h3 style={{ marginLeft: 10 }}>
											{timeConvertbus(location.state.item.arrivalTime)}
										</h3>
									</Box>
									<p style={{ marginTop: 20 }}>{location.state.item.busType}</p>
								</Grid>
								<Grid item xs={6}>
									<Grid container spacing={2}>
										<Grid item xs={6}>
											<Box>
												<span style={{ fontSize: 15, fontWeight: 'bold' }}>
													Pickup Point
												</span>
												<p style={{ color: 'grey', fontSize: 12 }}>
													{location.state.board}
												</p>
												<span style={{ fontSize: 15, fontWeight: 'bold' }}>
													Seats Selected
												</span>
												<br></br>

												{location?.state?.selectSeat?.map((d) => {
													return (
														<span style={{ fontSize: 16, color: 'grey' }}>
															{d.name},
														</span>
													);
												})}
											</Box>
										</Grid>
										<Grid item xs={6}>
											<Box>
												<span style={{ fontSize: 15, fontWeight: 'bold' }}>
													Droping Point
												</span>
												<p style={{ color: 'grey', fontSize: 12 }}>
													{location.state.drop}
												</p>
											</Box>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Box>

						<Box
							mt={2}
							style={{
								boxShadow: '0 0 10px rgba(0,0,0,.3)',
								backgroundColor: '#FFF',
								borderRadius: 3,
								padding: 30,
							}}>
							<BusSummaryForm />
						</Box>
					</Grid>
					<Grid item xs={4}>
						<Box
							style={{
								boxShadow: '0 0 10px rgba(0,0,0,.3)',
								backgroundColor: '#FFF',
								// padding: 10,
							}}>
							<Box
								style={{
									backgroundColor: '#E1E1E1',
									color: 'rgba(0,0,0,.64)',
									padding: 10,
								}}>
								<span>Offers</span>
							</Box>
							<Box
								onClick={() => dispatch(setModal(true))}
								style={{
									padding: 12,
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'space-between',
									cursor: 'pointer',
								}}>
								<span style={{ fontSize: 16 }}>Have a coupan code ?</span>

								<ArrowForwardIosIcon
									style={{ fontSize: 16, color: 'orangered' }}
								/>
							</Box>
						</Box>
						<Box
							mt={4}
							style={{
								boxShadow: '0 0 10px rgba(0,0,0,.3)',
								backgroundColor: '#FFF',
								borderRadius: 3,
							}}>
							<Box style={{ backgroundColor: '#E1E1E1', padding: 10 }}>
								<span>Fare Summary</span>
							</Box>
							<Box style={{ padding: 10 }}>
								<Box
									mt={1}
									style={{ display: 'flex', justifyContent: 'space-between' }}>
									<span style={{ fontSize: 12 }}>Base Fare</span>
									<span style={{ fontSize: 12 }}>
										₹
										{location.state.selectSeat &&
											location.state.selectSeat.length > 0 &&
											location.state.selectSeat
												?.map((i) => parseInt(i.baseFare))
												.reduce((prev, next) => prev + next)}
									</span>
								</Box>
								<Box
									mt={1}
									style={{ display: 'flex', justifyContent: 'space-between' }}>
									<span style={{ fontSize: 12 }}>Taxes and Fees</span>
									<span style={{ fontSize: 12 }}>
										₹{' '}
										{location.state.selectSeat &&
											location.state.selectSeat.length > 0 &&
											location.state.selectSeat
												?.map((i) => parseInt(i.PGCharge))
												.reduce((prev, next) => prev + next)}
									</span>
								</Box>
								<Box
									mt={2}
									style={{ display: 'flex', justifyContent: 'space-between' }}>
									<span>You Pay</span>
									<span style={{ fontSize: 18 }}>
										₹{' '}
										{location.state.selectSeat &&
											location.state.selectSeat.length > 0 &&
											location.state.selectSeat
												?.map((i) => parseInt(i.fare))
												.reduce((prev, next) => prev + next)}
									</span>
								</Box>
							</Box>
						</Box>
					</Grid>
				</Grid>
			</Container>
			<CoupanModal />
			<Footer />
		</div>
	);
};

export default BusDetailPage;
